// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'D:/泰诺能源/nengyuan-yaokong/terra-ems-web-main-yaokong/src/models/constantModel';
import model_2 from 'D:/泰诺能源/nengyuan-yaokong/terra-ems-web-main-yaokong/src/models/crudModel';
import model_3 from 'D:/泰诺能源/nengyuan-yaokong/terra-ems-web-main-yaokong/src/models/dictModel';
import model_4 from 'D:/泰诺能源/nengyuan-yaokong/terra-ems-web-main-yaokong/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'constantModel', model: model_1 },
model_2: { namespace: 'crudModel', model: model_2 },
model_3: { namespace: 'dictModel', model: model_3 },
model_4: { namespace: '@@initialState', model: model_4 },
} as const
